import { useEffect, useState } from "react";
import { ModalBase } from "../../../../components/Modals/ModalBase";
import { useDispatch, useSelector } from "react-redux";
import { generalShowLoader } from "../../../../actions/general.actions";
import { getJsonDteHacienda, setDataFileCompras } from "../../../../actions/libros/libro-compras.actions";
import { fechaMayorActual } from "../../../../utils/stringDate";
import { decodificarBinarioUtf8, mapeoRowJSONCompras, mapeoRowJSONComprasVariante, mapeoRowRetencionXLSX, ordenarComprasPorFecha, validRowAnexo6Anticipo, validRowCompras } from "../../../../utils/cargas.utils";
import * as XLSX from 'xlsx';
import { setCargarAnexos } from "../../../../actions/libros/libros-ventas.actions";
import { State } from "../../../../reducers";

const optionsPlantillas = {
  compras: 'compras',
  anticipoAnexo6: 'anticipoAnexo6',
}

const optionsText: { [key in keyof typeof optionsPlantillas]: string } = {
  compras: 'Detalle de Compras',
  anticipoAnexo6: 'Anexo Anticipo a Cuenta IVA del 2% Efectuada al Declarante',
};

export default function ModalCargarFileCompras ({onClose, onAccept}: {onClose: any, onAccept: any}) {
  const dispatch = useDispatch();
  const {responseJSONHacienda, comprasDataLibros} = useSelector((state: State) => state.libros)
  
  const [selectPlantilla, setSelectPlantilla] = useState(optionsPlantillas.compras);
  const [varianteCargaCompras, setVarianteCargaCompras] = useState(false);
  const [fileName, setFileName] = useState('');
  const [dataFile, setDataFile] = useState<Array<any>>([]);
  const [fileBase64, setFileBase64] = useState('');
  const [fileExt, setFileExt] = useState('');
  const [error, setError] = useState('');
  const [warnEmpty, setWarnEmpty] = useState('');
  const [warnSinProveedor, setWarnSinProveedor] = useState('');

  const [form, setForm] = useState({ descripcion: '', fechaDeclaracion: '' })
  const [errorForm, setErrorForm] = useState({ descripcion: '', fechaDeclaracion: '' })

  useEffect(() => {
    if (responseJSONHacienda.length > 0) {
      switch (selectPlantilla) {
        case optionsPlantillas.compras: {
          // Procesar los datos obtenidos de Hacienda para el mapeo de compras y sumarlos
          // a los que ya se mapearon directo del archivo (lote mixto: unos completos, otros no)
          const mapeoCompras = mapeoRowJSONCompras(responseJSONHacienda);
          setDataFile((prevData) => ordenarComprasPorFecha([...prevData, ...mapeoCompras]));
          break;
        }
        default:
          break;
      }
    }
  }, [responseJSONHacienda]);

  useEffect(() => {
    if (selectPlantilla !== optionsPlantillas.compras || dataFile.length === 0) {
      setWarnSinProveedor('');
      return;
    }

    const sinProveedor = dataFile
      .map((item: any, idx: number) => idx + 1)
      .filter((_: any, idx: number) => !dataFile[idx]?.nombreProveedor);

    setWarnSinProveedor(
      sinProveedor.length > 0
        ? `Aviso: en el/los documento(s) #${sinProveedor.join(', #')} no se pudo obtener el nombre del proveedor. Esto puede pasar cuando el JSON que entrega ese proveedor no lo incluye, o su estructura es distinta a la esperada. El documento se puede cargar igual, pero revise y complete el nombre si lo necesita.`
        : ''
    );
  }, [dataFile, selectPlantilla]);

  useEffect(() => {
    if (form.fechaDeclaracion) {
      // Si existe el libro con ese valor colocar la descripcion
      const [anio, mes] = form.fechaDeclaracion.split('-');
      const libroExistente = comprasDataLibros?.find((libro) => libro?.fechadeclaracion === `${mes}/${anio}`);
      if (libroExistente) {
        setForm((prevForm) => ({...prevForm, descripcion: libroExistente.descripcion}));
      }
    }
  }, [form.fechaDeclaracion]);

  const handleAccept = async () => {
    if (!form.descripcion || !form.fechaDeclaracion) {
      setErrorForm({
        descripcion: validateFormChange("descripcion", form.descripcion),
        fechaDeclaracion: validateFormChange("fechaDeclaracion", form.fechaDeclaracion),
      });
      return;
    }

    if (!error && !warnEmpty) {
      if (dataFile?.length > 0) {
        switch (selectPlantilla) {
          case optionsPlantillas.compras:
            if (errorForm.descripcion || errorForm.fechaDeclaracion) return;
            dispatch(setDataFileCompras({ 
              dataFile, 
              fileBase64, 
              form: {
                ext: fileExt, 
                descripcion: form.descripcion, 
                declaracion: form.fechaDeclaracion,
                datosHacienda: dataFile,
                varianteCargaCompras,
              }
            }));
            onAccept();
            break;

          case optionsPlantillas.anticipoAnexo6:
            if (await dispatch(setCargarAnexos(fileBase64, fileExt, 6))) {
              onClose();
            }
            break;
        }
      } else {
        setError('Por favor, cargar archivo para validar los datos');
      }
    }
  }

  const handleOnChange = (e: any) => {
    const {name, value} = e.target;
    const error = validateFormChange(name, value);

    setForm((prevForm) => ({
      ...prevForm,
      [name]: value
    }))
    setErrorForm((prevErrForm) => ({
      ...prevErrForm,
      [name]: error
    }))
  }

  const validateFormChange = (name: string, value: string) => {
    let error = '';
    switch (name) {
      case "descripcion": 
        if (value === "") error = "El campo de descripción es obligatorio";
        break;
      case "fechaDeclaracion":
        if (value === "") error = "El campo de fecha es obligatorio";
        else if (!fechaMayorActual(value)) error = "La fecha no puede ser mayor al día de hoy"
    }
    return error;
  }

  const cleanEmptyData = (data: any, ext: string) => {
    // Filtrar los datos que no estén vacíos
    var resultCountCleaned:Array<any> = []; 
    // Mapeos al filtrar datos
    var resultMapPrev:Array<any> = []; 
    var countIndex = ext === ".xlsx" ? 2 : 1;
  
    // Verificar si alguna de las celdas de la fila está vacía
    var cleanedData = data.filter((row: any) => {
      var valid = false;
      var mapeoEnBusqueda:any = null;

      switch (selectPlantilla) {
        case optionsPlantillas.compras:
          [valid, mapeoEnBusqueda] = validRowCompras(row, ext);
          break;

        case optionsPlantillas.anticipoAnexo6:
          valid = validRowAnexo6Anticipo(row, ext);
          break;
      }

      if (!valid) {
        resultCountCleaned.push(countIndex);
      }

      if (mapeoEnBusqueda) {
        resultMapPrev.push(mapeoEnBusqueda);
      }

      countIndex++;
      return valid;
    });

    // Mapeos
    switch (selectPlantilla) {
      case optionsPlantillas.compras:
        if (ext === ".xlsx") {
          cleanedData = mapeoRowRetencionXLSX(cleanedData);
        } 
        else if (ext === ".json") {
          if (resultMapPrev?.length > 0) {
            // Asignar resultados mapeados anteriores
            cleanedData = resultMapPrev;
          }
        }
        break;
      default:
        break;
    }

    return [cleanedData, resultCountCleaned];
  };

  const onChangeFile = (e: any) => {
    try {
      dispatch(generalShowLoader(true));
      const files = e.target.files;

      if (selectPlantilla === optionsPlantillas.compras) {
        handleMultipleFiles(files);
      }
      else if (selectPlantilla === optionsPlantillas.anticipoAnexo6) {
        handleOneFile(files[0]);
      }
    } catch (error) {
      setError('Ocurrió un error al cargar el archivo, intenta cargarlo nuevamente.');
    } finally {
      dispatch(generalShowLoader(false));
    }
  }

  const handleMultipleFiles = async(files: Array<any>) => {
    var dataFiles: Array<any> = [];
    var extFile = '';

    // Promesa para leer archivos
    const readFile = (file: any): Promise<any> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const fileExtension = file.name.slice(file.name.lastIndexOf('.'));
        setFileExt(fileExtension.replace(".", ""));
        
        reader.onload = (evt: any) => {
          setFileName((filePrev) => {
            const newFileName = `${filePrev}, ${file.name}`;
            return newFileName.length > 60 ? newFileName.substring(0, 60) + '...' : newFileName;
          });
  
          const validTypes = ['.xlsx', '.json'];
          if (!validTypes.includes(fileExtension.toLowerCase())) {
            setError('Por favor, selecciona un archivo con una extensión válida. (.xlsx, .json)');
            return reject(new Error('Extensión de archivo no válida'));
          }
  
          let dataFile;
          if (fileExtension === '.xlsx') {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            dataFile = XLSX.utils.sheet_to_json(ws);
          } else if (fileExtension === '.json') {
            try {
              let jsonString = decodificarBinarioUtf8(evt.target.result);
              jsonString = jsonString.replace(/^[^\x20-\x7E]+/, '').trim(); // Elimina caracteres no deseados - BOM
              // Parsear a JSON
              dataFile = JSON.parse(jsonString);
              if (dataFile && !Array.isArray(dataFile)) {
                dataFile = [dataFile];
              }
            } catch (parseError) {
              setError('El archivo JSON no tiene un formato válido.');
              return reject(new Error('Error al parsear el archivo JSON'));
            }
          }
  
          resolve(dataFile);
        };
  
        reader.onerror = () => {
          reject(new Error('Error al leer el archivo'));
        };
  
        extFile = fileExtension;
        reader.readAsBinaryString(file);
      });
    };

    // Procesar archivos
    var errorFiles = false;
    for (var file of files) {
      if (file) {
        try {
          const fileData = await readFile(file);
          dataFiles = [...dataFiles, ...fileData];
        } catch (error) {
          errorFiles = true;
          setError(`Error al procesar los archivos ${file.name}, por favor validar su contenido y probar nuevamente`);
          break;
        }
      }
    }
    if (errorFiles) { return; }
    
    // Procesar data
    const [dataClean, resultClean] = cleanEmptyData(dataFiles, extFile);
    if (resultClean?.length > 0) {
      const camposEvaluados = extFile === '.json'
        ? 'código de generación, fecha de emisión y los datos del emisor (NIT, NRC, nombre)'
        : 'código de generación y fecha de emisión';
      setWarnEmpty(`Alerta: Se detectaron en los archivos cargados registros incorrectos (#${resultClean?.join(", #")}). \nPor favor revisar e intentar nuevamente. \nLos valores a evaluar son el ${camposEvaluados}.`);
    } else {
      setWarnEmpty('');
    }
    setDataFile(dataClean);
    setError('');

    // Para compras mandar a llamar el metodo de Hacienda para traer datos
    switch (selectPlantilla) {
      case optionsPlantillas.compras: {
        if (!dataClean?.length || extFile === ".xlsx") return;

        // Lote puede venir mixto: filas con el JSON completo del DTE (se usan directo) y
        // filas que solo trajeron código de generación + fecha (se reconsultan a Hacienda).
        const variantRows = dataClean.filter((row: any) => row?.identificacion);
        const plainRows = dataClean.filter((row: any) => !row?.identificacion);

        setDataFile(variantRows.length > 0 ? ordenarComprasPorFecha(mapeoRowJSONComprasVariante(variantRows)) : []);

        if (plainRows.length > 0) {
          dispatch(getJsonDteHacienda(plainRows));
        }
        break;
      }
      default:
        break;
    }
  }

  const handleOneFile = (file: any) => {
    const selectedFile = file;
    const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf('.'));
    setFileExt(fileExtension.replace(".", ""));

    if(selectedFile){
      const reader = new FileReader();
      reader.onload = (evt: any) => {
        setFileName(selectedFile.name);
        
        const validTypes = ['.xlsx', '.json']
        if(!validTypes.includes(fileExtension.toLowerCase())){
          setError('Por favor, selecciona un archivo con una extensión válida. (.xlsx, .json)')
          return;
        }

        var dataFile;
        if (fileExtension === '.xlsx') {
          const bstr = evt.target.result;
          const wb = XLSX.read(bstr, {type:'binary'});
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          dataFile = XLSX.utils.sheet_to_json(ws);
        } else if (fileExtension === '.json') {
          try {
            dataFile = JSON.parse(decodificarBinarioUtf8(evt.target.result));
            if (dataFile && !Array.isArray(dataFile)) {
              dataFile = [dataFile];
            }
          } catch (parseError) {
            setError('El archivo JSON no tiene un formato válido.');
            return;
          }
        }

        const [dataClean, resultClean] = cleanEmptyData(dataFile, fileExtension);
        if (resultClean?.length > 0) {
          setWarnEmpty(`Alerta: Se detectaron en el documento ${resultClean.length} registros incorrectos. \nPor favor revisar el archivo de carga e intentar nuevamente. \nFilas con error: ${resultClean?.join(", ")}.`);
        } else {
          setWarnEmpty('');
        }
  
        setDataFile(dataClean);
        setFileBase64(btoa(evt.target.result));
        setError('');
      }

      reader.readAsBinaryString(selectedFile);
    } else {
      setFileName('');
      setError('Por favor, seleccione un archivo');
    }
  }

  const handleChangePlantilla = (e: any) => {
    setDataFile([]);
    setError('');
    setFileBase64('');
    setFileName('');
    setFileExt('');
    setSelectPlantilla(e.target.value);
    setWarnEmpty('');
    setVarianteCargaCompras(false);
  }

  return (
    <ModalBase>
      <div className="dte-send-email-container">
        <div>
          <h3 className="card-title">Cargar archivo</h3>
        </div>
        <div className="separador"/>
        <div className='label-input'>
          <label htmlFor='tipoCarga' className='field-label m'>
            Tipo de carga
          </label>
          <select
            id='tipoCarga'
            name='tipoCarga'
            className='m text-field w-select'
            value={selectPlantilla}
            onChange={handleChangePlantilla}
          >
            {Object.entries(optionsPlantillas).map(([key, value]) => (
              <option key={key} value={value}>
                {optionsText[key as keyof typeof optionsPlantillas]}
              </option>
            ))}
          </select>
        </div>
        <p className="m" style={{ fontWeight: '400', margin: '0'}}>El formato JSON es el que se entrega por el proveedor y el formato XLSX es utilizado para cargar aquellos documentos donde no se entregó el json (si necesita el formato puede descargar en la pantalla previa).</p>
        <p className="m" style={{ fontWeight: '400', margin: '0'}}><b>Nota:</b> Al cargar un archivo en formato XLXS, asegúrese de que los datos estén con formato de texto para no sufrir alteraciones al realizar la carga.</p>
        {
          (selectPlantilla === optionsPlantillas.compras)
          &&
          (
            <>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='numId' className='field-label m'>
                    Nombre de Libro <span style={{color: 'red'}}>*</span>
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='descripcion'
                    data-name='descripcion'
                    placeholder={`Descripción`}
                    id='descripcion'
                    maxLength={100}
                    value={form.descripcion}
                    onChange={handleOnChange}
                  />
                  {errorForm.descripcion && <p className='alert s'>{errorForm.descripcion}</p>}
                </div>
                <div className='label-input'>
                  <label htmlFor='numId' className='field-label m'>
                    Fecha de Libro <span style={{color: 'red'}}>*</span>
                  </label>
                  <input
                    autoComplete='off'
                    type='month'
                    className='m text-field w-input'
                    name='fechaDeclaracion'
                    data-name='fechaDeclaracion'
                    placeholder={`Fecha declaración`}
                    id='fechaDeclaracion'
                    maxLength={100}
                    value={form.fechaDeclaracion}
                    onChange={handleOnChange}
                  />
                  {errorForm.fechaDeclaracion && <p className='alert s'>{errorForm.fechaDeclaracion}</p>}
                </div>
              </div>
            </>
          )
        }
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <div className='file-input'>
              <input 
                autoComplete='off'
                type='file' 
                className='text-field w-input upload_file_input file-input' 
                name='retencionesexcel' 
                id='retencionesexcel' 
                accept=".xlsx, .json"
                onChange={onChangeFile}
                multiple
              />
              <span className='m button'>Seleccionar archivo</span>
              <span className='label'>{fileName || 'Ningún archivo seleccionado (.xlsx, .json)'}</span>
            </div>
            {error && <p className='alert s'>{error}</p>} 
          </div>
        </div>
        {warnEmpty && <p className='alert s'>{warnEmpty}</p>}
        {warnSinProveedor && <p className='alert s' style={{ color: '#B8860B' }}>{warnSinProveedor}</p>}
        <div className="dte-send-email-footer" style={{marginTop: '16px'}}>
          <button className="button transparent w-inline-block" onClick={onClose}>
            Cancelar
          </button>
          <button className="button w-inline-block" onClick={handleAccept}>
            {
              (selectPlantilla === optionsPlantillas.compras)
              ? 'Validar datos'
              : 'Cargar'
            }
          </button>
        </div>
      </div>
    </ModalBase>
  )
}